<script>
	export let id = null;
	export let label = null;
	export let htmlLabel = null;
	export let value = null;
	export let maxLength = null;
	export let required = false;
	export let disabled = false;
	export let readonly = false;
	export let placeholder = null;
</script>

{#if label}
	<label for={id} class:isrequired={required}>{label}</label>
{:else if htmlLabel}
	<label for={id} class:isrequired={required}>{@html htmlLabel}</label>
{/if}
<input
	{id}
	class="form-control"
	type="text"
	{required}
	{disabled}
	{readonly}
	{placeholder}
	{maxLength}
	bind:value
	on:change
	on:input
/>
